import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { ReactComponent as GithubIcon } from '../images/github.svg';
import Paper from '@material-ui/core/Paper';
import AccountIcon from '@material-ui/icons/AccountCircle';
import Avatar from '@material-ui/core/Avatar';
import TextField from '@material-ui/core/TextField';
import EmailIcon from '@material-ui/icons/Email';
import LinkedInIcon from '../images/linkedin.png';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import SendIcon from '@material-ui/icons/Send';
import DiscordLogo from '../images/discord.png';
import DevpostLogo from '../images/devpost.png';
import Chip from '@material-ui/core/Chip';
import axios from 'axios';
import SlideTransition from '@material-ui/core/Slide';
import { apiURL } from '../util/config';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import green from '@material-ui/core/colors/green';
import CheckIcon from '@material-ui/icons/CheckCircle';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    title: {

    },
    header: {

        backgroundColor: theme.palette.custom.headerBack,
        boxShadow: "inset 0 0 20px rgba(0,0,0,.5)",
        textAlign: 'center',
        padding: theme.spacing.unit,
        paddingBottom: theme.spacing.unit * 2,
        
    },
    space: {
        marginTop: theme.spacing.unit * 1,
        marginBottom: theme.spacing.unit * 1,
    },

    body: {
        padding: theme.spacing.unit * 2,
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit,
    },
    white: {
        color: 'white',

    },

    linkedInButton: {
        color: 'white',
        backgroundColor: '#0077B5',
        '&:hover': {
          backgroundColor: '#006193',
        },
    },
    chipButton: {
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
        },
    },
    chipButtonDark: {
        backgroundColor: theme.palette.custom.dark,
        '&:hover': {
          backgroundColor: theme.palette.custom.darker,
        },
        '&:focus': {
            backgroundColor: theme.palette.custom.darker,
        },
        color: 'white'
    },
    linkedInIcon: {
        marginRight: theme.spacing.unit,
        marginLeft: theme.spacing.unit,
        height: '21px'
    },

    discordIcon: {
        height: '24px',
        marginLeft: theme.spacing.unit
    },

    icon: {
        width: '24px',
        height: '24px',
        marginLeft: theme.spacing.unit,
    },
    margin1: {
        margin: theme.spacing.unit
    },

    discordButton: {
        color: 'white',
        backgroundColor: '#394150',
        '&:hover': {
          backgroundColor: '#2b313c',
        },  
        
    },

    contactForm: {
        maxWidth: '500px',
        
    },
    paper: {
        padding: theme.spacing.unit * 4,
        textAlign: 'center'
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main
    },
    divider: {

        width: '75%'
    },
    textField: {
        
    },
    links: {
        [theme.breakpoints.down("sm")]: {
            marginBottom: theme.spacing.unit * 4
          }
        
    },
    button: {
        marginTop: theme.spacing.unit
    },
    buttonWidth: {
      
        width: '300px',

    },
    
    emailButton: {
        color: 'white',
        backgroundColor: '#e91e63',
        '&:hover': {
          backgroundColor: '#b0003a',
        },  
    },

    fillWhite: {
        fill: 'white'
    },

    devpostButton: {
        color: 'white',
        backgroundColor: '#64dd17',
        '&:hover': {
          backgroundColor: '#1faa00',
        },  
    },

    chip: {
        paddingTop: theme.spacing.unit * 3,
        paddingBottom: theme.spacing.unit * 3,
        width: '300px',
    },
    iconButton: {


    },
    send: {
        color: 'white',
        height: '19px',
        width: '19px',
        '&:hover': {
            color: theme.palette.primary.dark,
          }, 
        
    },
    linksContainer: {
        
    },

    snack: {
        maxWidth: '250px'
    },
    check: {
        margin: theme.spacing.unit
    }
});

class Contact extends React.Component {

    state = {
        open: false,
        snackOpen: false,
        slide: false,
        errors: null,
        error: '',
        sent: false, 
        Name: '', 
        Email: '', 
        Message: ''
    }

    sendMessage = async() => {

        const me = this;
        this.setState({error: '', errors: null});

        await axios.post(apiURL+"/Message/Create", {

            Name: this.state.Name,
            Email: this.state.Email,
            Content: this.state.Message

        })
        .then((res) => {
            
            this.setState({NameSent: this.state.Name, sent: true, Name: '', Email: '', Message: ''});

        })
        .catch(function (error) { 
            
            if (error.response && error.response.status === 400) {
                me.setState({errors: error.response.data.errors});
            } else {
                me.setState({error: 'Unknown error sending message'});
            }

        });

    }

    handleClose = () => {
        this.setState({sent: false});
    }

    getErrors = (key) => {
        
        if (this.state.errors && this.state.errors[key]) {
            return this.state.errors[key];
        }
        
        return null;

    }

    onChange = (e) => {

        this.setState({[e.target.id]: e.target.value});

    }

    handleOpenMobile = e => {
        this.setState({mobileOpen: true});
    }
    handleOpenDesktop = e => {
        this.setState({desktopOpen: true});
    }

    handleClick = () => {
        this.setState({ snackOpen: true });
      };
    
    handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        this.setState({ snackOpen: false });
      };



    render() {

        const { classes } = this.props;

        const { slide, sent } = this.state;

            return (
                
                <Grid item xs={12} className={classes.root}>
                    <Grid container justify="center" alignItems="center" className={classes.header}>
                        <Grid item xs={12} className={classes.space}>
                            <Typography variant="h2" className={classes.white} >
                                Contact Me
                            </Typography>
                            
                        </Grid>
                        <Grid item xs={12} className={classes.space}>
                            <Typography variant="body1" className={classes.white} >
                                Get in touch with me through social media or send a message using the contact form below
                            </Typography>
                        </Grid>
                        <Grid item xs={12} className={classes.space}>
                            <Grid container justify="center" alignItems="center" spacing={8}>
                                <Grid item>
                                    <SlideTransition direction="down" in={true} mountOnEnter unmountOnExit style={{ transitionDelay: '250ms' }}>
                                        
                                        <Chip
                                            avatar={<Avatar><EmailIcon/></Avatar>}
                                            label="Email: Jordanr3@live.com"
                                            variant="outlined"
                                            color="primary"
                                            clickable
                                            onClick={() => {this.handleClick(); navigator.clipboard.writeText("Jordanr3@live.com");}}
                                        />
                                        </SlideTransition>
                                        <Snackbar
                                            open={this.state.snackOpen}
                                            onClose={this.handleSnackClose}
                                            autoHideDuration={3000}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            }}
                                            ContentProps={{
                                                "aria-describedby": "message-id"
                                            }}
                                            message={<span id="message-id">Email copied to clipboard</span>}
                                            action={[
                                                <IconButton
                                                    key="close"
                                                    aria-label="Close"
                                                    color="inherit"
                                                    className={classes.close}
                                                    onClick={this.handleSnackClose}
                                                >
                                                    <CloseIcon />
                                                </IconButton>,
                                                ]}
                                            />
                                </Grid>
                                
                                <Grid item>   
                                    <SlideTransition direction="down" in={true} mountOnEnter unmountOnExit style={{ transitionDelay: '500ms' }}>
        
                                            <Chip
                                                avatar={<Avatar><GithubIcon /></Avatar>}
                                                label="Github: jriley15"
                                                clickable
                                                color="primary"
                                                classes={{root: classes.chipButton}}
                                                onClick={() => window.open("https://github.com/jriley15", "_blank")}
                                            />
                                    </SlideTransition>
                                        
                                </Grid>

                                <Grid item>   
                                    <SlideTransition direction="down" in={true} mountOnEnter unmountOnExit style={{ transitionDelay: '750ms' }}>        
                                        <Chip
                                            avatar={<Avatar><img src={LinkedInIcon} style={{width: '23px', height: '19px'}}/></Avatar>}
                                            label="Linked In"
                                            clickable
                                            classes={{root: classes.chipButton}}
                                            onClick={() => window.open("https://www.linkedin.com/in/jordan-riley-090564158/")}
                                        />    
                                    </SlideTransition> 
                                </Grid>
                                <Grid item>   
                                    <SlideTransition direction="down" in={true} mountOnEnter unmountOnExit style={{ transitionDelay: '1000ms' }}>              
                                        <Chip
                                            avatar={<Avatar><img src={DiscordLogo} /></Avatar>}
                                            label="Discord: JORDAN#8399"
                                            clickable
                                            classes={{root: classes.chipButtonDark}}
                                            onClick={() => {}}
                                        />    
                                    </SlideTransition>
                                </Grid>
                                <Grid item>            
                                    <SlideTransition direction="down" in={true} mountOnEnter unmountOnExit style={{ transitionDelay: '1250ms' }}>     
                                        <Chip
                                            avatar={<Avatar><img src={DevpostLogo} style={{width: '23px', height: '19px'}} /></Avatar>}
                                            label="Devpost"
                                            variant="outlined"
                                            clickable
                                            color="primary"
                                            onClick={() => window.open("https://devpost.com/JordanRiley")}
                                        />
                                    </SlideTransition>    
                                </Grid>
                            
                            </Grid>
                        </Grid>

                        <Grid item>
                                                                    
                        </Grid>  
                    </Grid>
                    <Grid container justify="center" alignItems="center" className={classes.body} >
                        <Grid item sm={12} md={10}>
                            <Grid container justify="center" alignItems="center" spacing={16} >
                                <Grid item xs={12} sm={8} md={6} className={classes.contactForm}>
                                    <Paper className={classes.paper}>
                                        <Grid container justify="center" alignItems="center" >
                                            <Grid item>
                                                <Avatar className={classes.avatar}>
                                                    <AccountIcon fontSize="large" />         
                                                </Avatar>                           
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Typography variant="h5">
                                                    Contact Form
                                                </Typography>                   
                                            </Grid>
        
                                            <Grid item xs={12}>
                                                <Grid container justify="center" alignItems="center" spacing={16} >
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            id="Name"
                                                            label="Name"
                                                            className={classes.textField}
                                                            margin="normal"
                                                            fullWidth
                                                            onChange={this.onChange}
                                                            required
                                                            error={this.getErrors("Name") !== null}
                                                            helperText={this.getErrors("Name")}
                                                            value={this.state["Name"]}
                                                        /> 
                                                    </Grid>  
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            id="Email"
                                                            label="Email Address"
                                                            className={classes.textField}
                                                            margin="normal"
                                                            fullWidth
                                                            onChange={this.onChange}
                                                            required
                                                            error={this.getErrors("Email") !== null}
                                                            helperText={this.getErrors("Email")}
                                                            value={this.state["Email"]}
                                                        /> 
                                                    </Grid>      
                                                </Grid>                    
                                            </Grid>
                                            <Grid item xs={12} className={classes.textField}>
                                            <TextField
                                                id="Message"
                                                label="Message"
                                                margin="normal"
                                                variant="outlined"
                                                multiline
                                                rows={10}
                                                className={classes.textField}
                                                fullWidth
                                                onChange={this.onChange}
                                                value={this.state["Message"]}
                                                required
                                                error={this.getErrors("Content") !== null}
                                                helperText={this.getErrors("Content")}
                                            />
                                            </Grid>
                                            <Grid item className={classes.button}>
                                                <Button color="secondary" variant="outlined" onClick={this.sendMessage}>
                                                    Send Message
                                                    <SendIcon className={classes.icon} />
                                                </Button>                                            
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>      
                        </Grid>                       
                    </Grid>     

                        <Dialog
                            open={this.state.sent}
                            onClose={this.handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >

                            <Grid container justify="center" alignItems="center">
                                <Grid item>
                                    <CheckIcon fontSize="large" style={{color: green[500]}} />
                                </Grid>
                                <Grid item>
                                    <DialogTitle id="alert-dialog-title">Thank you {this.state.NameSent}</DialogTitle>
                                </Grid>
                                <Grid item>
                                    <DialogContent>
                                        <DialogContentText style={{textAlign: 'center'}} id="alert-dialog-description">
                                            Your message has been sent straight to my email and I will get back to you as soon as possible.
                                        </DialogContentText>
                                    </DialogContent>
                                </Grid>
                                <Grid item>
                                    <DialogActions>
                                        <Button onClick={this.handleClose} color="secondary" variant="outlined" autoFocus>
                                            Ok
                                        </Button>
                                    </DialogActions>
                                </Grid>
                            </Grid>



                        </Dialog>               
                </Grid>
            );
        
    }

}

export default withStyles(styles)(Contact);